<div class="component-container flex flex-col justify-center items-center">
  <app-toggle-button
    (handleToggle)="toggleButtonClicked($event)"
    *ngIf="groupId"
    [disable]="groupDetailsLoader"
    [selectedValue]="displayGroupsScreen"
    class="toggle-button w-[30%]"
    labelFalse="Sessions"
    labelTrue="Groups"
  ></app-toggle-button>
  <div class="screen w-full">
    <app-group-details-screen-shimmer-loader
      *ngIf="groupDetailsLoader || duplicateGroupLoader; else groupDetailsSection"
    >
    </app-group-details-screen-shimmer-loader>
    <ng-template #groupDetailsSection>
      <app-group-details-screen
        (handleContinueClick)="onContinue($event)"
        (handleStartDateChange)="changeResetSessionsList($event)"
        *ngIf="displayGroupsScreen; else displaySessions"
        [groupId]="groupId"
        [onPreviousData]="payload"
      ></app-group-details-screen>
      <ng-template #displaySessions>
        <app-group-sessions-screen
          (handlePreviousClick)="onPrevious($event)"
          [clientId]="clientId"
          [editable]="sessionEditable"
          [groupId]="groupId"
          [groupStatus]="groupDetails?.status"
          [payload]="payload"
          [resetSessionsList]="resetSessionsList"
          [startDateTime]="startDateTime"
        ></app-group-sessions-screen>
      </ng-template>
    </ng-template>
  </div>
</div>
